export const getMapInfoWindowContentString = (
    addr: string,
    city: string,
    state: string
): string => {
    return `<div id="content">
        <h3 id="firstHeading">${addr}</h3>
        <h4 id="firstHeading">${city}, ${state}</h4>
      </div>`;
};
